import { Binary } from "@angular/compiler"
import { Version } from "@app/shared/models/version.model"

export interface Import {
    id: string
    name: string
    description: string
    culture: {
        id: string
        text: string
    }
    sheetName: string
    startingRow: number
    status: {
        id: string
        name: string
    }
    table: {
        id: string
        name: string
    }
    columnMappings: {
        sheetColumn: string
        tableField: {
            id: string
            name: string
            format: string
        }
        createLookupIfMissing: boolean
        type: {
            id: string
            name: string
        }
    }[]
    file: string
    version: Version
}

export interface ImportSumbit {
    name: string
    description: string
    culture: string
    sheetName: string
    startingRow: number
    table: string
    columnMappings: {
        sheetColumn: string
        tableField: string
        createLookupIfMissing: boolean
        type: string
    }[]
}

export interface ImportFileUpload {
    name: string,
    file: string
}

export interface ImportStatus {
    id: string
    name: string
}

export interface ImportLog {
    import: {
        id: string
    }
    runTime: string
    row: number
    column: string
    message: string
    logType: {
        id: string
        name: string
    }
}